import HeadingOne from "../../components/HeadingOne";

interface ListItemProps {
  label: React.ReactNode;
  value: React.ReactNode;
  actions?: React.ReactNode;
}
export function ListItem(props: ListItemProps) {
  return (
    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
      <dt className="text-sm font-medium leading-6 text-gray-900">
        {props.label}
      </dt>
      <dd className="mt-1 flex text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
        <span className="flex-grow overflow-x-auto">{props.value}</span>
        <span className="ml-4 flex-shrink-0">{props.actions}</span>
      </dd>
    </div>
  );
}

interface Props {
  title: string;
  children: {
    listItems: React.ReactNode;
  };
}
export default function CallsEditLayout(props: Props) {
  return (
    <>
      <HeadingOne>{props.title}</HeadingOne>
      <div className="mt-6 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">{props.children.listItems}</dl>
      </div>
    </>
  );
}
